import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { Box, Divider, Switch, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { AutoBlockExplanation } from './components'

import useStyles from './styles'

const AutoBlockSettings = () => {
  const { control } = useFormContext()

  const classes = useStyles()

  return (
    <>
      <Box p={2}>
        <Alert severity="info" className={classes.alert}>
          <Typography variant="body2" className={classes.alertText}>
            Os cookies de Funcionalidade, Analíticos ou de desempenho e
            Publicidade são sempre bloqueados até o visitante consentir.
          </Typography>
        </Alert>
        <Box className={classes.mainRow}>
          <Box>
            <Typography
              component="label"
              htmlFor="auto-block-unknown"
              className={classes.mainLabel}
            >
              Bloquear cookies não categorizados automaticamente
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Cookies da categoria Outros, que o scanner não reconheceu.
              Bloqueá-los pode comprometer o funcionamento do site.
            </Typography>
          </Box>
          <Controller
            control={control}
            name="autoBlockUnknown"
            valueName="checked"
            onChange={([, checked]) => checked}
            as={
              <Switch
                id="auto-block-unknown"
                edge="end"
                color="default"
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.checked,
                  track: classes.track,
                }}
              />
            }
          />
        </Box>
      </Box>
      <Divider />
      <AutoBlockExplanation />
    </>
  )
}

export default AutoBlockSettings
